import { Card, Radio, Skeleton, Tabs, theme } from "antd";
import React, { useEffect, useState } from "react";
import CustomHeader from "../common/Header";
import HTTP from "../../services/httpService";
import HotelList from "../common/HotelList";
import {
    AppstoreOutlined,
    AlertOutlined,
    ToolOutlined,
    SmileOutlined,
    ClusterOutlined,
} from "@ant-design/icons";
import "./Hotel.css";

const deviceOptions = [
    { label: "Aavgo", value: "1" },
    { label: "Aavya", value: "2" },
    { label: "Lenovo", value: "3" },
];

function Category() {
    const { token } = theme.useToken();
    const staff_id = localStorage.getItem("x-dashboard-staffid");

    const [tableData, setTableData] = useState([]);
    const [SelectedDeviceOptions, setSelectedDeviceOptions] = useState(0);
    const [showSkeleton, setShowSkeleton] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [currentPageLimit, setCurrentPageLimit] = useState(0);
    const [activeKey, setActiveKey] = useState("KioskHotels");

    useEffect(() => {
        async function fetchData() {
            const { data: response, total } = await HTTP(
                "/dashboard/getKioskHotels",
                {
                    staff_id,
                    page: 0,
                    limit: 10,
                },
            );
            setCurrentPage(1);
            setCurrentPageLimit(10);
            setTotalRecords(total);
            setShowSkeleton(false);
            if (response.length > 0) setTableData(response);
        }
        fetchData();
    }, []);

    async function changeView(key_url) {
        const [key, site] = key_url.split("-");
        setActiveKey(key_url);
        setTableData([]);
        setShowSkeleton(true);
        setCurrentPage(1);
        setCurrentPageLimit(10);

        const formData = { staff_id, page: 0, limit: 10 };
        if (key === "GuestExperienceHotels") {
            formData.type = 1;
            setSelectedDeviceOptions("1");
        }
        if (key === "SiteWiseHotels") formData.site = site;

        const { data: response, total } = await HTTP(
            `/dashboard/get${key.trim()}`,
            formData,
        );
        setTotalRecords(total);
        setShowSkeleton(false);
        if (response.length > 0) setTableData(response);
    }

    async function fatchGuestExperienceHotels(
        e,
        page = 0,
        limit = 10,
        sorting = undefined,
        sort_by = undefined,
        pageChanged = false,
    ) {
        setSelectedDeviceOptions(e.target.value);
        setCurrentPage(page + 1);
        setCurrentPageLimit(limit);
        if (!pageChanged) {
            setTableData([]);
            setTotalRecords(0);
            setShowSkeleton(true);
        }

        const formData = { staff_id, type: e.target.value, page, limit };
        if (sort_by !== undefined && sorting !== undefined) {
            formData.sort_by = sort_by;
            formData.sorting = sorting;
        }
        const { data: response, total } = await HTTP(
            "/dashboard/getGuestExperienceHotels",
            formData,
        );
        setTotalRecords(total);
        setShowSkeleton(false);
        if (response.length > 0) setTableData(response);
    }

    async function handlePageChange(...rest) {
        const [params] = rest;
        const { page, limit, key, sorting, sort_by, site } = params;
        setCurrentPage(page + 1);
        setCurrentPageLimit(limit);

        const formData = { staff_id, page, limit };
        if (sorting !== undefined && sort_by !== undefined) {
            formData.sorting = sorting;
            formData.sort_by = sort_by;
        }
        if (key === "GuestExperienceHotels") {
            setSelectedDeviceOptions("1");
            return fatchGuestExperienceHotels(
                { target: { value: SelectedDeviceOptions } },
                page,
                limit,
                sorting,
                sort_by,
                true,
            );
        }
        if (site) formData.site = site;

        const { data: response, total } = await HTTP(
            `/get${key.trim()}`,
            formData,
        );
        setTotalRecords(total);
        if (response.length > 0) {
            setTableData(
                response.map((e) => ({
                    ...e,
                    address: `${e.street}, ${e.city}, ${e.state}, ${e.zipcode}`,
                })),
            );
        }
    }

    // Shared table-or-skeleton renderer
    const TableOrSkeleton = ({ id, site }) =>
        showSkeleton ? (
            <Skeleton
                active
                title={false}
                paragraph={{ rows: 10, width: "100%" }}
            />
        ) : (
            <div className="hotel-list-wrapper">
                <HotelList
                    tableData={tableData}
                    id={id}
                    noOfrecords={totalRecords}
                    handlePageChange={handlePageChange}
                    currentPage={currentPage}
                    currentPageLimit={currentPageLimit}
                    site={site}
                />
            </div>
        );

    const tabItems = [
        {
            key: "KioskHotels",
            label: (
                <span className="hotel-tab-label">
                    <AppstoreOutlined /> Kiosk
                </span>
            ),
            children: (
                <div className="hotel-tab-content">
                    <TableOrSkeleton id="KioskHotels" />
                </div>
            ),
        },
        {
            key: "PanicHotels",
            label: (
                <span className="hotel-tab-label">
                    <AlertOutlined /> Panic
                </span>
            ),
            children: (
                <div className="hotel-tab-content">
                    <TableOrSkeleton id="PanicHotels" />
                </div>
            ),
        },
        {
            key: "OperationalHotels",
            label: (
                <span className="hotel-tab-label">
                    <ToolOutlined /> Operational
                </span>
            ),
            children: (
                <div className="hotel-tab-content">
                    <TableOrSkeleton id="OperationalHotels" />
                </div>
            ),
        },
        {
            key: "GuestExperienceHotels",
            label: (
                <span className="hotel-tab-label">
                    <SmileOutlined /> Guest Exp.
                </span>
            ),
            children: (
                <div className="hotel-tab-content">
                    <div className="guest-device-filter">
                        <span
                            style={{
                                fontSize: 12,
                                color: token.colorTextTertiary,
                                fontWeight: 500,
                            }}
                        >
                            Device:
                        </span>
                        <Radio.Group
                            options={deviceOptions}
                            onChange={fatchGuestExperienceHotels}
                            value={SelectedDeviceOptions}
                            optionType="button"
                            buttonStyle="solid"
                            size="small"
                        />
                    </div>
                    <TableOrSkeleton id="GuestExperienceHotels" />
                </div>
            ),
        },
        {
            key: "SiteWiseHotels-a",
            label: (
                <span className="hotel-tab-label">
                    <ClusterOutlined /> Site A
                </span>
            ),
            children: (
                <div className="hotel-tab-content">
                    <TableOrSkeleton id="SiteWiseHotels" site="a" />
                </div>
            ),
        },
        {
            key: "SiteWiseHotels-b",
            label: (
                <span className="hotel-tab-label">
                    <ClusterOutlined /> Site B
                </span>
            ),
            children: (
                <div className="hotel-tab-content">
                    <TableOrSkeleton id="SiteWiseHotels" site="b" />
                </div>
            ),
        },
    ];

    return (
        <Card className="dashboard-container">
            <CustomHeader />

            {/* ── Page header ── */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    margin: "16px 0 20px",
                }}
            >
                <div>
                    <h2
                        style={{
                            fontSize: 22,
                            fontWeight: 700,
                            color: token.colorText,
                            margin: 0,
                            letterSpacing: "-0.01em",
                            fontFamily: token.fontFamily,
                        }}
                    >
                        Hotel Directory
                    </h2>
                    <p
                        style={{
                            fontSize: 13,
                            color: token.colorTextTertiary,
                            margin: "4px 0 0",
                        }}
                    >
                        Browse and manage hotels across all categories
                    </p>
                </div>

                {/* Count pill */}
                {!showSkeleton && (
                    <div
                        style={{
                            background: `${token.colorPrimary}15`,
                            border: `1px solid ${token.colorPrimary}33`,
                            borderRadius: token.borderRadius,
                            padding: "8px 20px",
                            textAlign: "center",
                        }}
                    >
                        <div
                            style={{
                                fontSize: 22,
                                fontWeight: 700,
                                color: token.colorPrimary,
                            }}
                        >
                            {totalRecords}
                        </div>
                        <div
                            style={{
                                fontSize: 11,
                                color: token.colorTextTertiary,
                            }}
                        >
                            Hotels
                        </div>
                    </div>
                )}
            </div>

            {/* ── Tabs ── */}
            <Tabs
                activeKey={activeKey}
                onChange={changeView}
                destroyOnHidden
                type="card"
                className="hotel-category-tabs"
                tabBarStyle={{ marginBottom: 0 }}
                items={tabItems}
            />
        </Card>
    );
}

export { Category };
